import { useState } from 'react';
import giftCardsApis from '../apis';
import { IResponseTableData, IResponseTableDataBody } from 'services/response';
import { IRedeemTracking } from '../types/redeem';
import dayjs, { Dayjs } from 'dayjs';
import { IGetListRedeemTracking } from '../types/api';

type FilterType = {
  page: number;
  size: number;
  keySearch: string;
  action: string;
  startDate: Dayjs;
  endDate: Dayjs;
};

export const initialFilterRedeemTracking: FilterType = {
  page: 1,
  size: 10,
  keySearch: '',
  action: 'REDEEMED',
  startDate: dayjs(),
  endDate: dayjs(),
};

export type IUseGetRedeemTracking = {
  data: IResponseTableData<IRedeemTracking> | undefined;
  filter: FilterType;
  loading: boolean;
  search: (filter: FilterType) => void;
  setfilter: (filter: FilterType) => void;
};

const useGetRedeemTracking = (): IUseGetRedeemTracking => {
  const [data, setData] = useState<IResponseTableData<IRedeemTracking>>();
  const [loading, setLoading] = useState(false);
  const [filter, setfilter] = useState<FilterType>(initialFilterRedeemTracking);

  const search = async (filter: FilterType) => {
    setLoading(true);
    try {
      const params: IGetListRedeemTracking = {
        ...filter,
        startDate: dayjs(filter.startDate).format('MM-DD-YYYY'),
        endDate: dayjs(filter.endDate).format('MM-DD-YYYY'),
      };
      setfilter(filter);
      const res: IResponseTableDataBody<IRedeemTracking> = await giftCardsApis.getRedeemTracking(params);
      if (res.data.data) {
        setData(res.data.data);
      }
    } catch (error) {
      setData(undefined);
    } finally {
      setLoading(false);
    }
  };

  return { data, filter, loading, search, setfilter };
};

export default useGetRedeemTracking;
